export default __webpack_public_path__ + "static/media/getReadyExam.55715627.png";